<table width="100%" border="0" cellspacing="0" cellpadding="0" id="principal"
       style="height: 100%; table-layout: fixed; overflow: hidden;">
  <!--ESTRUTURA TABLE PARA ***FullScreen*** -->
  <tr>
    <td width="100%" valign="middle" class="naoSelecionavel">
      <mat-sidenav-container class="sidenav-container">


      <!-- MENU  -->
          <mat-sidenav #drawer class="sidenav" fixedInViewport
              [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
              [mode]="(isHandset$ | async) ? 'over' : 'side'"
              [opened]="(isHandset$ | async) === false"
              >


            <div style=" text-align: center; margin-bottom: 20px; position: absolute; top: 50px; left: 70px;">
              <div>
                <img src="../../assets/img/logoQualidade.png" width="150px">
              </div>
            </div>

            <div style="height: 160px; color: white; width: 100%;
                                                  border-radius: 0px 0px 0px 0px ;
                                                  ">
                <br/><br/> <br/>
                <div class="text-center font-weight-normal" >
                  <br/>
                  <img src="../../assets/img/pluris_midia_logo.png" width="180px; ">
                </div>


            </div>



            <div style="margin-top: 10px; overflow-y: hidden; overflow-x: hidden; " >
              <mat-nav-list>




                <nav class="navbar navbar-light bg-lignt" style="padding: 0px; margin-top: 35px;">
                  <div class="navbar-collapse" id="collapsingNavbar2">
                      <ul class="navbar-nav ">

                      <!-- Monitoria -->
                        <li style="height: 22px; margin-top: 2px;">
                          <div style="width: 100%; margin-top: 0px; z-index: 1000;  ">
                            <div style="width: 100%; text-align: center; ">
                                <div style="width: 99%; font-size: 14px; background-color: rgb(207, 121, 1); color: white;
                                            height: 20px; border-radius: 0px 30px 0px 0px ; ">
                                  <div style="position: relative; top: 0px;">Monitoria</div>
                              </div>
                            </div>
                          </div>

                        </li>

                        <li class="nav-item active" style="width: 99%; height: 30px; margin-left: 1px; ">
                          <a mat-list-item routerLink="/home/monitoria" routerLinkActive="active-list-item" style="height: 30px; ">
                            <mat-icon>broken_image</mat-icon> &nbsp;&nbsp; Monitoria &nbsp;&nbsp;<i>(Atendimentos)</i> </a>
                        </li>

                        <li class="nav-item active" style="width: 99%; height: 30px; margin-left: 1px; " *ngIf="isExcluirFicha">
                          <a mat-list-item routerLink="/home/exclusoesPendentes" routerLinkActive="active-list-item" style="height: 30px; ">
                            <mat-icon>delete_forever</mat-icon> &nbsp;&nbsp;Exclusões&nbsp;Pendentes&nbsp;&nbsp;<i>(Monitoria)</i></a>
                        </li>

                        


                      <!-- Relatórios -->
                      <!-- <li style="height: 22px; margin-top: 20px;">
                        <div style="width: 100%; margin-top: 0px; z-index: 1000;  ">
                          <div style="width: 100%; text-align: center; ">
                              <div style="width: 99%; font-size: 14px; background-color: rgb(207, 121, 1); color: white;
                                          height: 20px; border-radius: 0px 30px 0px 0px ; ">
                                <div style="position: relative; top: 0px;">Relatórios</div>
                            </div>
                          </div>
                        </div>
                      </li>


                      <li class="nav-item" style="width: 99%; height: 30px; margin-left: 1px; ">
                        <a mat-list-item routerLink="/home/relatorio" routerLinkActive="active-list-item" style="height: 30px;">
                          <mat-icon>contact_mail</mat-icon> &nbsp;&nbsp;  Relatorio 1 &nbsp;&nbsp; <i>(E-mail)</i>
                        </a>
                      </li>
                      <li class="nav-item" style="width: 99%; height: 30px; margin-left: 1px; ">
                        <a mat-list-item routerLink="/home/relatorio" routerLinkActive="active-list-item" style="height: 30px;">
                          <mat-icon>contact_phone</mat-icon> &nbsp;&nbsp; Relatorio 2 &nbsp;&nbsp; <i>(Telefone)</i>
                        </a>
                      </li>
                      <li class="nav-item" style="width: 99%; height: 30px; margin-left: 1px; ">
                        <a mat-list-item routerLink="/home/relatorio" routerLinkActive="active-list-item" style="height: 30px;">
                          <mat-icon>chat</mat-icon> &nbsp;&nbsp; Relatorio 3 &nbsp;&nbsp; <i>(Chat)</i>
                        </a>
                      </li> -->

                       <!-- Cadastro -->
                      <li style="height: 22px; margin-top: 20px;" *ngIf="isAdmin || isMonitor">
                        <div style="width: 100%; margin-top: 0px; z-index: 1000;  ">
                          <div style="width: 100%; text-align: center; ">
                              <div style="width: 99%; font-size: 14px; background-color: rgb(207, 121, 1); color: white;
                                          height: 20px; border-radius: 0px 30px 0px 0px ; ">
                                <div style="position: relative; top: 0px;">Cadastro</div>
                            </div>
                          </div>
                        </div>
                      </li>

                      <li class="nav-item" style="width: 99%; height: 30px; margin-left: 1px; " *ngIf="isAdmin">
                        <a mat-list-item routerLink="/home/cadOperacao" routerLinkActive="active-list-item" style="height: 30px;">
                          <mat-icon>domain</mat-icon> &nbsp;&nbsp; Operação &nbsp;&nbsp; <i>(Empresa)</i>
                        </a>
                      </li>
                      <li class="nav-item" style="width: 99%; height: 30px; margin-left: 1px; " *ngIf="isAdmin">
                        <a mat-list-item routerLink="/home/cadUsuario" routerLinkActive="active-list-item" style="height: 30px;">
                          <mat-icon>people</mat-icon> &nbsp;&nbsp;  Usuários &nbsp;&nbsp; <i>(Funcionários)</i>
                        </a>
                      </li>
                      <li class="nav-item" style="width: 99%; height: 30px; margin-left: 1px; " *ngIf="isAdmin">
                        <a mat-list-item routerLink="/home/cadFichaMonitoria" routerLinkActive="active-list-item" style="height: 30px;">
                          <mat-icon>library_books</mat-icon> &nbsp;&nbsp; Formularios &nbsp;&nbsp; <i>(Monitoria)</i>
                        </a>
                      </li>
                      <li class="nav-item" style="width: 99%; height: 30px; margin-left: 1px; " *ngIf="isMonitor">
                        <a mat-list-item routerLink="/home/parecerPlanoDeAcao" routerLinkActive="active-list-item" style="height: 30px; ">
                          <mat-icon>group_work</mat-icon> &nbsp;&nbsp; Plano de ação / Parecer &nbsp;&nbsp; </a>
                      </li>

                      </ul>

                    </div>

                  </nav>

              </mat-nav-list>
              <br/>
              <div style="width: 180px; white-space: nowrap; overflow: hidden; position: absolute; bottom: 10px; left: 10px; font-size: 12px;
                text-overflow: ellipsis; color: white;">
                Bem Vindo {{nomeUser}} [ {{idRe}} ] <!-- - {{idUser}}-->
              </div>
            </div>

          </mat-sidenav>







          <!-- PARTE SUPERIOR ("CABEÇALHO DA TELA") -->
          <mat-sidenav-content style="overflow: hidden;">
            <mat-toolbar class="backgroundSuperior" style="height: 55px; overflow: hidden;">
              <!--
              <button
                type="button"
                aria-label="Toggle sidenav"
                mat-icon-button
                (click)="drawer.toggle()"
                *ngIf="isHandset$ | async">
                <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
              </button>-->

              <button style="color: white; background-color: rgb(152, 204, 253);"
                type="button"
                aria-label="Toggle sidenav"
                mat-icon-button
                (click)="drawer.toggle()"
                >
                <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
              </button>



              <div style="width: 300px; text-align: center; ">
                <div>
                  <img src="../../assets/img/pluni.png" width="40px">&nbsp;&nbsp;
                  <img src="../../assets/img/icones/facebook.png" width="30px">&nbsp;&nbsp;
                  <img src="../../assets/img/icones/twitter.png" width="30px">&nbsp;&nbsp;
                  <img src="../../assets/img/icones/youtube.png" width="30px">
                </div>
              </div>


              <span class="example-spacer"></span>

                <button (click)="sair()" mat-icon-button class="example-icon">
                  <img src="../../assets/img/icones/cancel.png" width="40px">
                </button>
                &nbsp;&nbsp;

              <mat-card style="border-radius: 30px 0px 0px 30px ; color: white; height: 100%; width: 40px;
                background-color: rgb(46, 163, 80); margin-right: -30px;">
              </mat-card>

            </mat-toolbar>

            <div style="width: 100%; margin-top: 0px; z-index: 1000;  ">
              <div style="width: 100%; text-align: left; ">
                  <div class="marcadorSuperior" style="width: 100%;">
                </div>
              </div>
            </div>

            <!-- CONTEUDO DA ROTA (TELAS SELECIONADAS) -->
            <div style="height: 100vw;">
                <router-outlet></router-outlet>
            </div>



          </mat-sidenav-content>
        </mat-sidenav-container>
      </td>

    </tr>


    <!-- RODAPE -->
    <tr style=" width: 100%; ">
      <td width="100%" text-align="center" valign="middle" style="position:absolute; bottom: 0px; background-color: rgb(207, 121, 1);">

        <mat-toolbar color="primary" style="height: 5px;background-color: rgb(207, 121, 1);">
          <!--<div style="font-size: 12px; width: 100%; height: 20px;
                      text-align: center; color:white;
                      background-color: rgb(46, 163, 80)">
            <div style="position:relative;top: -5px;">©Copyright 2022 por Plurismidia SA. Todos os direitos reservados.</div>
          </div>-->
        </mat-toolbar>

      </td>
    </tr>

  </table>
